// extracted by mini-css-extract-plugin
export default {"loader":"LoaderSpinner_loader__TFiWg","rotation":"LoaderSpinner_rotation__eKZMC","container":"LoaderSpinner_container__3xJ9h"};